export default Fretes;

import * as moment from 'moment';
import * as _ from 'lodash';

import 'moment/locale/pt-br';

/** @ngInject */
function Fretes(Api, Usuario, $filter) {
  let vm = this;
  let cache = {}, cacheId = 'fretes';
  let arrIdTipoPreco = {2: 'p/ qtd.', 3: 'p/ ton.', 4: 'p/ km'};
  let currency = $filter('currency');
  let mask = $filter('mask');
  let cep: any = _.partialRight(mask, '99999-999');

  vm.LIMIT = 20;

  vm.limparFiltro = limparFiltro;
  vm.buscarFretes = buscarFretes;
  vm.buscarFrete = buscarFrete;
  vm.formatarDadosFrete = formatarDadosFrete;
  vm.formatarDadosFreteDetalhe = formatarDadosFreteDetalhe;
  vm.obterTiposPedagio = obterTiposPedagio;
  vm.tiposRaio = obterTiposRaio();
  vm.tiposVeiculos = Usuario.tiposVeiculos;
  vm.tiposCarroceria = Usuario.tiposCarroceria;
  vm.tiposOrdenacao = Usuario.tiposOrdenacao;

  vm.salvarCache = salvarCache;
  vm.obterCache = obterCache;
  vm.setarCacheId = (id: string) => cacheId = id;
  vm.limparCache = () => cache[cacheId] = [];

  limparFiltro();

  function limparFiltro() {
    let usuario = Usuario.obterUsuario();
    vm.filtro = {
      raio: Usuario.find(vm.tiposRaio, 0.5),
      tipoVeiculo: Usuario.find(vm.tiposVeiculos, usuario.id_tipo_veiculo || 0),
      tipoCarroceria: Usuario.find(vm.tiposCarroceria, usuario.id_tipo_carroceria || 0),
      ordenacao: vm.tiposOrdenacao[0]
    };
  }

  function buscarFretes(filtro) {
    return Api
      .buscarDados('LoteCarregamentoDivulgacao', 'buscarFretes', {filtro: filtro})
      .then(fretes => {
        return (fretes || []).map(formatarDadosFrete);
      });
  }

  function buscarFrete(base, codigo, filtro) {
    return Api
      .buscarDados('LoteCarregamentoDivulgacao', 'buscarFrete', {base: base, codigo: codigo, filtro: filtro})
      .then(formatarDadosFreteDetalhe);
  }

  function formatarVlPreco(frete) {
    if (frete && frete.cd_lote) {
      var vlPreco = frete.vl_tarifa_motorista > 0 ? currency(frete.vl_tarifa_motorista, 'R$ ') : '';
      var dsPreco = arrIdTipoPreco[frete.id_calculo_tarifa_cf];
      frete.ds_preco = vlPreco ? [vlPreco, dsPreco].join(' ') : 'A combinar';
    }
  }

  function formatarDtCadastro(frete) {
    if (frete && frete.dt_cadastro) {
      frete.dt_cadastro = moment(frete.dt_cadastro).fromNow();
    }
  }

  function formatarDadosPedagio(frete) {

    var campo = (frete.pedagio || []).length === 0 ? 'vl_pedagio' : 'ds_pedagio';

    if (frete.id_pedagio === '0') {
      frete.pedagio = [];
      frete.vl_pedagio = 'Trajeto s/ Pedágio';
    } else if (parseInt(frete.id_pedagio, 10) >= 2) {
      frete[campo] = '+ Pedágio';
    } else {
      frete[campo] = 'Incluso no Frete';
    }
  }

  function formatarDadosFrete(frete) {
    formatarDtCadastro(frete);
    formatarVlPreco(frete);
    return frete;
  }

  function formatarTipos(arrOptions, arrIds) {
    var filtro = obj => arrIds && arrIds.indexOf(obj.id + '') !== -1;

    return _.filter(arrOptions, filtro).map(o => o.label).join(', ');
  }

  function implode(list, str) {
    return _.compact(list).join(str);
  }

  function formatarDadosFreteDetalhe(frete) {
    formatarDadosFrete(frete);
    formatarDadosPedagio(frete);

    frete.nr_cep_agencia = cep(frete.nr_cep_agencia);
    frete.nr_cep_matriz = cep(frete.nr_cep_matriz);
    frete.ds_endereco_agencia = implode([frete.ds_endereco_agencia, frete.nr_cep_agencia], ', ');
    frete.ds_endereco_matriz = implode([frete.ds_endereco_matriz, frete.nr_cep_matriz, frete.nm_cidade_matriz], ', ');

    frete.ds_tipo_veiculo = formatarTipos(vm.tiposVeiculos, frete.id_tipo_veiculo);
    frete.ds_tipo_carroceria = formatarTipos(vm.tiposCarroceria, frete.id_tipo_carroceria);

    frete.direction = JSON.parse(frete.ds_direction);

    frete.ds_observacao = (frete.ds_observacao || '').replace(/[\n]/g, '<br />');

    return frete;
  }

  function obterTiposPedagio() {
    return {
      2: '02 Eixos',
      5: '03 Eixos',
      8: '04 Eixos',
      10: '05 Eixos',
      11: '06 Eixos',
      13: '07 Eixos',
      14: '08 Eixos',
      15: '09 Eixos',
      16: 'p/ Eixo',
      17: 'p/ Peso (Kg)'
    };
  }

  function obterTiposRaio() {
    return [
      {id: 0.05, label: '5 km'},
      {id: 0.5, label: '50 km'},
      {id: 1, label: '100 km'},
      {id: 1.5, label: '150 km'},
      {id: 2, label: '200 km'}
    ];
  }

  function salvarCache(filtro, fretes, index: number) {
    cache[cacheId] = cache[cacheId] || [];
    cache[cacheId].splice(index);
    cache[cacheId].push({filtro: filtro, fretes: fretes});
  }

  function obterCache(index: number) {
    cache[cacheId] = cache[cacheId] || [];
    return cache[cacheId][index] || {};
  }
}



/** WEBPACK FOOTER **
 ** ./common/services/fretes.service.ts
 **/